import { createContext } from 'react'

import {
  ILayout,
} from '@kaidam/fc-shared/src/types/layout'

export interface IData_Command_Context_Extractor {
  (): ILayout,
}

export interface IData_Command_Context {
  setExtractor: {
    (extractor: IData_Command_Context_Extractor): void,
  },
  removeExtractor: {
    (): void,
  },
}

const CommandContext = createContext<IData_Command_Context>({
  setExtractor: () => {},
  removeExtractor: () => {},
})

export default CommandContext